var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2641 0H0.735917C0.332357 0 0 0.324341 0 0.73125V13.2688C0 13.6698 0.326422 14 0.735917 14H11.2641C11.6677 14 12 13.6757 12 13.2688V0.73125C11.9941 0.324341 11.6677 0 11.2641 0ZM6.53413 8.71019H2.48071C2.09495 8.71019 1.78042 8.39764 1.78042 8.01432C1.78042 7.631 2.09495 7.31845 2.48071 7.31845H6.53413C6.91989 7.31845 7.23442 7.631 7.23442 8.01432C7.23442 8.39764 6.91989 8.71019 6.53413 8.71019ZM9.51929 5.9326H2.48071C2.09495 5.9326 1.78042 5.62006 1.78042 5.23674C1.78042 4.85342 2.09495 4.54087 2.48071 4.54087H9.51929C9.90505 4.54087 10.2196 4.85342 10.2196 5.23674C10.2196 5.62006 9.90505 5.9326 9.51929 5.9326ZM9.51929 3.15502H2.48071C2.09495 3.15502 1.78042 2.84247 1.78042 2.45915C1.78042 2.07583 2.09495 1.76326 2.48071 1.76326H9.51929C9.90505 1.76326 10.2196 2.07583 10.2196 2.45915C10.2196 2.84247 9.90505 3.15502 9.51929 3.15502Z",
    fill: "#89898A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputDocumentIcon);
export default __webpack_public_path__ + "static/media/input-document-icon.49b87d48ec4d07b029480e34d318abf7.svg";
export { ForwardRef as ReactComponent };